import { KeycloakUserInfo } from './types/KeycloakUserInfo';
import { logger } from '@crx-dev/hss-react-infrastructure';

let keycloak: typeof Keycloak;
export async function init(keycloakConfig: object, realm: string): Promise<null | KeycloakUserInfo> {
    try {
        keycloak = new Keycloak({
            ...keycloakConfig,
            realm
        });

        const authenticated = await keycloak.init({
            onLoad: 'login-required',
            checkLoginIframe: false
        });

        if (authenticated) {
            const user = await keycloak.loadUserInfo();
            localStorage.clear();

            return {
                name: user.name,
                roles: user.roles,
                email: user.email,
                isLocum: keycloak.hasRealmRole('Locum')
            };
        }
    } catch (e) {
        logger.log('Error', `Keycloak: ${e} `);
    }

    return null;
}

export async function getToken() {
    await keycloak.updateToken(30);
    return keycloak.token;
}

export function logout() {
    localStorage.clear();
    keycloak.logout();
}
